import { HistoryIcon, LayoutDashboardIcon, PlusCircleIcon } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "../../lib/utils";
import { Badge } from "../ui/badge";

export function Footer() {
  const location = useLocation();
  const path = location.pathname;

  return (
    // <footer className="w-full h-20 flex items-center justify-center bg-background p-4 rounded-t-2xl border-t-2 border-border shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
    <footer className="my-5">
      <div className="flex flex-col items-center gap-1 text-xs text-muted-foreground sm:flex-row sm:justify-between sm:px-10">
        <p className="flex gap-2 items-center"> Atendimento 24h:
          <Badge variant="default" className="bg-blue-100 border-blue-500 text-blue-500 font-bold">0800 038 1506</Badge>
          <Badge variant="default" className="bg-blue-100 border-blue-500 text-blue-500 font-bold">(21) 2762 - 5350</Badge>
        </p>
        <p className="text-purple-500">© NovaNet Internet Solutions LTDA - Nova ISP.</p>
        <p>© 2026 Indique e Ganhe. Todos os direitos reservados.</p>
      </div >

      {/* <ul className="w-full max-w-md h-14 flex items-center justify-evenly text-sm">
        <li>
          <Link
            to="/dashboard"
            className={cn(
              "flex flex-col items-center gap-1 transition-colors",
              path === "/dashboard" ? "text-primary font-semibold" : "text-muted-foreground hover:text-foreground"
            )}
          >
            <LayoutDashboardIcon className="w-5 h-5" />
            <span>Dashboard</span>
          </Link>
        </li>
        <li>
          <Link
            to="/indicate"
            className={cn(
              "flex flex-col items-center gap-1 transition-colors",
              path === "/indicate" ? "text-primary font-semibold" : "text-muted-foreground hover:text-foreground"
            )}
          >
            <PlusCircleIcon className="w-5 h-5" />
            <span>Indicar</span>
          </Link>
        </li>
        <li>
          <Link
            to="/history"
            className={cn(
              "flex flex-col items-center gap-1 transition-colors",
              path === "/history" ? "text-primary font-semibold" : "text-muted-foreground hover:text-foreground"
            )}
          >
            <HistoryIcon className="w-5 h-5" />
            <span>Histórico</span>
          </Link>
        </li>
      </ul> */}
    </footer >
  );
}